import { memo, useMemo } from "react";

import { CartLineProvider } from "@shopify/hydrogen-react";
import {
  type CartLine,
  type SelectedOption,
} from "@shopify/hydrogen-react/storefront-api-types";

import { isDefaultOption } from "@react/utilities";

import { CartProductGiftItemView } from "./CartProductGiftItem.view";

type Props = {
  cartLineUpdating: boolean;
  giftLine: CartLine;
  linkAriaLabel?: string;
  selectedOptions: Partial<SelectedOption>[] | undefined;
  shippingNote: string | null;
};

const CartProductGiftItemBase = ({
  cartLineUpdating,
  giftLine,
  linkAriaLabel,
  shippingNote,
}: Props) => {
  const validSelectedOptions = useMemo(
    () =>
      giftLine.merchandise?.selectedOptions
        ?.filter((o): o is SelectedOption => !!o)
        .filter((o) => !isDefaultOption(o)),
    [giftLine.merchandise?.selectedOptions]
  );

  return (
    <CartLineProvider line={giftLine}>
      <CartProductGiftItemView
        cartLineUpdating={cartLineUpdating}
        cost={giftLine.cost}
        linkAriaLabel={linkAriaLabel}
        merchandise={giftLine.merchandise}
        selectedOptions={validSelectedOptions}
        shippingNote={shippingNote}
      />
    </CartLineProvider>
  );
};

export const CartProductGiftItem = memo(CartProductGiftItemBase);
